var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('AppChip',_vm._g(_vm._b({attrs:{"class-list":"ml-1","color":"edit","text-color":"white--text"}},'AppChip',attrs,false),on),[_vm._v("\n      "+_vm._s(_vm.$t("people:personPage.hasDebts.label", "Debts"))+"\n    ")])]}}])},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(
      "people:personPage.hasDebts.hint",
      "Outstanding payments. Check Shopping Basket for details"
    )))])])
}
var staticRenderFns = []

export { render, staticRenderFns }